import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'

type Props = {
  id: string
}

export const BecomeAClient = ({ id }: Props) => {
  const navigate = useNavigate()
  const { formatMessage } = useIntl()

  return (
    <section id={id} className="py-[100px] px-4 xl:px-[91px] bg-[#DFEAF0]">
      <div className="flex flex-col items-center text-justify max-w-[1264px] mx-auto">
        <h2 className="text-2xl md:text-[36px] leading-[60px] mb-10 text-center uppercase font-openSans text-[#068A8A] font-bold">
          {formatMessage({ id: 'BECOME_A_CLIENT' })}
        </h2>
        <div className="text-[#131313] md:leading-9 md:text-2xl text-base font-normal font-montserrat mb-10">
          <p>
            {formatMessage({ id: 'BECOME_A_CLIENT_TEXT' })}
          </p>
        </div>
        <button
          className="font-openSans text-base text-white leading-[24px] h-12 py-3 px-6 font-semibold uppercase bg-[#042F49] rounded-lg whitespace-nowrap hover:bg-[#2DC6C6] hover:text-[#001D2F] shadow-[0px_6px_4px_0px_rgba(224,224,224,0.20)]"
          onClick={() => navigate('/contact-us')}
        >
          {formatMessage({ id: 'BECOME_A_CLIENT' })}
        </button>
      </div>
    </section>
  )
}
